'use strict';

wbApp.factory('errorTypeTranslateSvc', ['$translate', 
    function ($translate) {

        function translate(error, attr, scope) {
            var errors = '';

            attr = attr || {};

            switch (error) {
                case "email":
                    errors += $translate.instant("TXT_ERROR_INVALID_EMAIL");
                    break;
                case "required":
                    errors += $translate.instant("TXT_ERROR_REQUIRED");
                    break;
                case "maxlength":
                    errors += $translate.instant("TXT_ERROR_MAX_LENGTH");
                    if (attr.ngMaxlength) {
                        errors += ' (' + attr.ngMaxlength + ')';
                    }
                    break;
                case "minlength":
                    errors += $translate.instant("TXT_ERROR_MIN_LENGTH");
                    if (attr.ngMinlength) {
                        errors += '(' + attr.ngMinlength + ')';
                    }
                    break;
                case "isBefore":
                    errors += $translate.instant("TXT_ERROR_IS_BEFORE");
                    if (attr.wbIsBeforeValidator) {
                        var val1 = scope.$eval(attr.wbIsBeforeValidator);
                        errors += moment(val1).format('L');
                    }
                    break;
                case "isAfter":
                    errors += $translate.instant("TXT_ERROR_IS_AFTER");
                    if (attr.wbIsAfterValidator) {
                        var val2 = scope.$eval(attr.wbIsAfterValidator);
                        errors += moment(val2).format('L');
                    }
                    break;
                case "pattern":
                    errors += $translate.instant("TXT_ERROR_PATTERN");
                    break;
                case "uniqueEmail":
                    errors += $translate.instant("TXT_ERROR_UNIQUE_EMAIL");
                    break;
                case "uniqueUserName":
                    errors += $translate.instant("TXT_ERROR_UNIQUE_USER_NAME");
                    break;
                case "uniqueTenant":
                    errors += $translate.instant("TXT_ERROR_UNIQUE_TENANT_NAME");
                    break;
                case "sameValue":
                    if (attr.wbSameValueValidatorMessage) {
                        errors += attr.wbSameValueValidatorMessage;
                    } else {
                        errors += $translate.instant("TXT_ERROR_UNIQUE_USER_NAME");
                    }
                    break;
                case "differentValue":
                    if (attr.wbDifferentValueValidatorMessage) {
                        errors += attr.wbDifferentValueValidatorMessage;
                    } else {
                        errors += $translate.instant("TXT_ERROR_UNIQUE_USER_NAME");
                    }
                    break;
                case "onlyOneValueSet":
                    if (attr.wbOnlyOneValueSetValidatorMessage) {
                        errors += attr.wbOnlyOneValueSetValidatorMessage;
                    } else {
                        errors += $translate.instant("TXT_ERROR_ONLY_ONE_VALUE_CAN_BE_SET");
                    }
                    break;
                case "dependentPropertyRequired":
                    if (attr.wbDependentPropertyRequiredValidator) {
                        errors += attr.wbDependentPropertyRequiredValidatorMessage;
                    } else {
                        errors += $translate.instant("TXT_ERROR_ONLY_ONE_VALUE_CAN_BE_SET");
                    }
                    break;
                case "mask":
                    errors += $translate.instant("TXT_ERROR_PATTERN");
                    break;
                case "number":
                    errors += $translate.instant("TXT_ERROR_NUMBER");
                    break;
                case "min":
                    errors += $translate.instant("TXT_ERROR_MIN");
                    if (attr.min) {
                        errors += ' (' + attr.min + ')';
                    } else {
                        if (attr.minTime) {
                            errors += ' (' + attr.minTime + ')';
                        }
                    }
                    break;
                case "max":
                    errors += $translate.instant("TXT_ERROR_MAX");
                    if (attr.max) {
                        errors += ' (' + attr.max + ')';
                    } else {
                        if (attr.maxTime) {
                            errors += ' (' + attr.maxTime + ')';
                        }
                    }
                    break;
            }

            return errors;
        }

        return {
            translate: translate
        }
    }]);